import React from 'react'
import { Payments } from './Payments'

export const Layout = () => {
  return <Payments />
}
